import {
  Send,
  CheckCircle2,
  XCircle,
} from 'lucide-react';
import type { PurchaseRequest } from '../../types';

interface TimelineTabProps {readonly request: PurchaseRequest;}

export function TimelineTab({ request }: TimelineTabProps) {
  const formatDateTime = (dateStr: string) =>
    new Date(dateStr).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

  const events = [
    {
      date: request.createdAt,
      title: 'Request Created',
      description: `Created by ${request.createdByName}`,
      icon: Send,
    },
  ];

  if (request.status === 'approved' && request.approvedAt) {
    events.push({
      date: request.approvedAt,
      title: 'Request Approved',
      description: `Approved by ${request.approvedByName}`,
      icon: CheckCircle2,
    });
  }

  if (request.status === 'rejected') {
    events.push({
      date: request.updatedAt,
      title: 'Request Rejected',
      description: request.rejectionReason ?? 'No reason provided',
      icon: XCircle,
    });
  }

  events.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-900">Activity Timeline</h3>
      <div className="space-y-4">
        {events.map((event) => (
          <div key={`${event.title}-${event.date}`} className="flex gap-4">
            <div className="flex flex-col items-center">
              <div className="rounded-full bg-primary/10 p-2">
                <event.icon className="h-4 w-4 text-primary" />
              </div>
            </div>
            <div className="pb-4">
              <p className="font-medium text-gray-900">{event.title}</p>
              <p className="text-sm text-gray-500">{event.description}</p>
              <p className="text-xs text-gray-400 mt-1">{formatDateTime(event.date)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
